module.exports = __webpack_public_path__ + "img/symbol_hashyellow.27bc7b8e.png";